// Single source of truth for the bid_lines.scope_flag enum and how each
// flag maps onto the jobs row columns the schedule board / job detail
// already display via lib/jobScopeDisplay.

export const SCOPE_FLAG_LABELS = {
  tdi: 'TDI',
  in_place: 'In Place',
  deep_end: 'Deep End',
  haul: 'Haul',
  water: 'Water',
  sand: 'Sand',
  main_drain: 'Main Drain',
}

export const INSTALL_TYPE_LABELS = {
  install: 'Install',
  liner: 'Liner',
  repair: 'Repair',
  other: 'Other',
}

// Order matches the override dropdown order. "Auto-detect" (null) is
// rendered separately so the trigger can re-detect from description on save.
export const SCOPE_FLAG_OPTIONS = [
  'tdi', 'in_place', 'deep_end', 'haul', 'water', 'sand', 'main_drain',
]

// Drives the read-only "Scope (synced from bid)" panel and the editable
// version on un-linked jobs. Each entry maps a bid_lines.scope_flag value
// onto the boolean column on the jobs row that the trigger writes.
export const JOB_SCOPE_COLUMNS = [
  { flag: 'tdi',        column: 'is_tdi',              label: 'TDI' },
  { flag: 'in_place',   column: 'in_place_of_old_pool', label: 'In Place' },
  { flag: 'deep_end',   column: 'has_deep_end',        label: 'Deep End' },
  { flag: 'haul',       column: 'dirt_haul_away',      label: 'Haul' },
  { flag: 'water',      column: 'water_delivery',      label: 'Water' },
  { flag: 'sand',       column: 'sand_delivery',       label: 'Sand' },
  { flag: 'main_drain', column: 'has_main_drain',      label: 'Main Drain' },
]

// Mirror of the trigger's pool-line regex. Used to decide whether the owner
// gets the "Mark as primary pool line" checkbox in the bid line editor —
// otherwise the toggle is noise on Riverbend / extras.
const POOL_LINE_RE = /(round|oval)\s+(install|liner)/i

export function isPoolLineDescription(description) {
  if (!description) return false
  return POOL_LINE_RE.test(String(description))
}

// Compute the bid editor's header summary from the loaded bid_lines.
// Returns { sizeLabel, installLabel, flagLabels } — null fields render as "—".
export function summarizeBidScope(lines) {
  var arr = Array.isArray(lines) ? lines : []
  var primary = arr.find(function(l) { return l && l.is_primary_pool_line === true }) || null
  var sizeLabel = primary?.derived_pool_size || null
  var installLabel = primary?.derived_install_type
    ? (INSTALL_TYPE_LABELS[primary.derived_install_type] || null)
    : null
  // Dedupe and order by SCOPE_FLAG_OPTIONS so the summary reads consistently.
  var seen = new Set()
  arr.forEach(function(l) { if (l?.scope_flag) seen.add(l.scope_flag) })
  var flagLabels = SCOPE_FLAG_OPTIONS
    .filter(function(f) { return seen.has(f) })
    .map(function(f) { return SCOPE_FLAG_LABELS[f] })
  return { sizeLabel: sizeLabel, installLabel: installLabel, flagLabels: flagLabels }
}
